module.exports = __webpack_public_path__ + "img/banner-bg_4.097e9eb0.png";